<!-- @format -->

<template>
	<el-form
		ref="form"
		v-loading="loading"
		element-loading-text="加载中"
		:label-suffix="':'"
		:label-position="'top'"
		class="inner-detail"
	>
		<el-row :gutter="30">
			<el-col :span="12">
				<el-form-item :label="'主题'">
					<span>{{ form.title }}</span>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item :label="'创建时间'">
					<span>{{ form.createTime }}</span>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item :label="'发送人'">
					<span>{{ form.name }}</span>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item :label="'消息类型'">
					<el-tag :type="$utils.optionsFilter(form.noticeType, typeOptions, 'type')">
						{{ $utils.optionsFilter(form.noticeType, typeOptions, 'label') }}
					</el-tag>
				</el-form-item>
			</el-col>
			<el-col :span="24">
				<el-form-item :label="'消息内容'">
					<div class="original-content" v-html="htmlFilter(form.content)" />
				</el-form-item>
			</el-col>
		</el-row>
	</el-form>
</template>

<script>
	import { $utils } from '@/utils/publicUtils';
	export default {
		props: {
			inside: {
				type: Boolean,
				default: false,
			},
			visible: {
				type: Boolean,
				default: false,
			},
			readonly: {
				type: Boolean,
				default: false,
			},
			detailData: {
				type: Object,
			},
			id: String,
			title: String,
		},
		data() {
			return {
				$utils,
				typeOptions: [
					{
						value: '',
						label: '全部',
					},
					{
						value: 'inner',
						label: '内部消息',
					},
					{
						value: 'sms',
						label: '短信',
						type: 'danger',
					},
					{
						value: 'email',
						label: '邮件',
						type: 'info',
					},
					{
						value: 'dingding',
						label: '钉钉',
						type: 'warning',
					},
					{
						value: 'wechat',
						label: '企业微信',
						type: 'success',
					},
				],
				loading: false,
				form: {},
			};
		},
		beforeUnmount() {
			this.typeOptions = null;
			this.form = null;
		},
		methods: {
			// 获取表单数据
			getFormData() {
				this.form = this.detailData;
			},
			// 字符过滤器
			htmlFilter(text) {
				const matchList = {
					'&lt;': '<',
					'&gt;': '>',
					'&amp;': '&',
					'&#34;': '"',
					'&quot;': '"',
					'&#39;': "'",
				};
				if (text === null || text === undefined || text === '') return text || '';
				let regStr = `(${Object.keys(matchList).toString()})`;
				regStr = regStr.replace(/,/g, ')|(');
				const regExp = new RegExp(regStr, 'g');
				return text.replace(regExp, (match) => matchList[match]);
			},
		},
	};
</script>
<style lang="scss">
	.inner-detail {
		.original-content {
			p {
				margin: 0;
			}
		}
	}
</style>
